(function() {
    'use strict';

    angular
        .module('garanteasyApp')
        .controller('FeedbackDetailController', FeedbackDetailController);

    FeedbackDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Principal', 'Feedback', 'User'];

    function FeedbackDetailController($scope, $rootScope, $stateParams, previousState, entity, Principal, Feedback, User) {
        var vm = this;

        vm.feedback = entity;
        
        if($stateParams.from) {
            $scope.from = $stateParams.from
        }

        var unsubscribe = $rootScope.$on('garanteasyApp:feedbackUpdate', function(event, result) {
            vm.feedback = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
